import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Meta from "../../components/Meta"
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BlogPost from "../../components/BlogPost";
import "../../styles/blog.css";
import { Api } from "./Api";

console.log(Api);

const BlogHome = () => {
  const [blogPost, setBlogPost] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await axios.get(`${Api}?_embed`);
        setBlogPost(result.data);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  console.log(blogPost);

  return (
    <div>
      <Meta title="Wedevelopers - Blog" />
      <div className="herobg">
        <Header />
        <section className="bloghero container text-white d-flex align-items-center">
          <div>
            <h2 className="mb-25 font-heading text-white">
              The Wedevelopers Blog
            </h2>
            <p className="font-normal">
              Updates and announcements from Team Wedevelopers!
            </p>
            {/* <form>
              <div className="d-flex align-items-center">
                <input type="email" placeholder="Enter email" />
                <button
                  className="primary-btn lemon-btn px-1 py-50"
                  type="submit" disabled>
                  Subscribe
                </button>
              </div>
            </form> */}
          </div>
        </section>
      </div>
      <nav className="py-1 text-black border-bottom">
        <div className="container">
          <ul className="navbar-nav d-flex wrap text-uppercase font-weight-bolder">
            <li className="mr-3 py-50">
              <a to="#" className="font-normal">
                All
              </a>
            </li>
            {/* <li className="mr-3 py-50">
              <a to="#" className="text-black font-normal">
                Engineering And Design
              </a>
            </li>
            <li className="mr-3 py-50">
              <a to="#" className="text-black font-normal">
                Getting Started
              </a>
            </li>
            <li className="mr-3 py-50">
              <a to="#" className="text-black font-normal">
                Company News
              </a>
            </li> */}
          </ul>
        </div>
      </nav>
      <section className="py-3">
        <div className="container">
          {loading ? (
            <div>Loading ...</div>
          ) : (
            <div>
              {blogPost.map((post) => (
                <BlogPost key={post.id} post={post} />
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default BlogHome;
